import request from 'sb-request'
import query from './stateRecommendationsQuery.graphql'

/**
 * fetch products for PopularInStatesPage page
 * @param {String} state
 * @param {String} gender
 * @returns {*}
 */
const fetchProducts = (state, gender) =>
  request.post('graphql?name=stateRecommendations', {
    body: {
      query,
      variables: {
        state,
        gender,
        limit: 3,
        // TODO magic constant, we should do something with it - added on 2020-01-17 by maddoger
        offset: 19,
      },
    },
  })
    .then(
      ({ items = [] }) => items,
      () => []
    )


export default {
  fetchProducts,
}
